import { ContainerJourneySimpleResponseDto } from '@planning/app/api'
import containerJourneysService from '@planning/services/containerJourneys'
import { AppViewStore } from '@planning/stores/AppViewStore'
import { action, makeObservable, observable } from 'mobx'

export class YardClerkViewStore {
  filteredContainerJourneys: ContainerJourneySimpleResponseDto[] = []
  isDrawerOpen = false
  selectedJourney?: ContainerJourneySimpleResponseDto

  handleUpdatePosition?: (journeyId: number) => Promise<void>

  constructor(private readonly appViewStore: AppViewStore) {
    makeObservable(this, {
      filteredContainerJourneys: observable,
      isDrawerOpen: observable,
      selectedJourney: observable,
      searchContainerJourneys: action,
      openDrawer: action,
      closeDrawer: action,
    })
  }

  async searchContainerJourneys(filter?: string) {
    if (!filter) {
      this.filteredContainerJourneys = []
      return
    }

    this.appViewStore.showLoader()

    const result = await containerJourneysService.getByPartialContainerNumber(filter, true)

    this.appViewStore.hideLoader()

    this.filteredContainerJourneys = result || []
  }

  async openDrawer(journeyId: number) {
    const journey = this.filteredContainerJourneys.find(j => j.id === journeyId)
    if (journey) {
      this.selectedJourney = journey
      this.isDrawerOpen = true
    }
  }

  async updatePosition(journeyId: number) {
    this.appViewStore.showLoader()

    await this.handleUpdatePosition?.(journeyId)

    this.appViewStore.hideLoader()
  }

  closeDrawer() {
    this.selectedJourney = undefined
    this.isDrawerOpen = false
  }
}
